interface AuthSocialButtonProps extends React.ComponentProps<"button"> {}

export function AuthSocialButton({ ...rest }: AuthSocialButtonProps) {
  return <button className="auth-social-button" {...rest} />;
}
